export default "__VITE_ASSET__DpWyzCBx__"